<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                    <v-select
                            :items="$store.state.companies"
                            v-model="company"
                            label="Seleccione compañia"
                            item-value="id"
                            item-text="name"
                            single-line
                            :rules="[v => !!v || 'Campo requerido']"
                            return-object
                            persistent-hint
                            required
                    >
                    </v-select>
                </v-flex>
            </v-layout>
        </v-form>
        <td>
            <download-excel :fetch="generateReportGrupoHomogenio"
                            style="width:200px"
                            name="reporte_grupo_homogenio.xls">
                <v-btn color="primary" :disabled="!valid">
                    Reporte de Grupo Homogéneo
                    <v-icon right dark>cloud_download</v-icon>
                </v-btn>
            </download-excel>
            <br>
            <download-excel :fetch="generateReportMatrizRiesgo"
                            style="width:200px"
                            name="reporte_matriz_riesgo.xls">
                <v-btn color="secondary" :disabled="!valid">
                    Reporte de Matriz de Riesgo
                    <v-icon right dark>cloud_download</v-icon>
                </v-btn>
            </download-excel>
        </td>
    </v-container>
</template>
<script>

    export default {
        data() {
            return {
                valid: false,
                search: '',
                dialogDownloadReport: false,
                urlDownloadReport: "",
                pagination: {
                    sortBy: 'date',
                    descending: true
                },
                typeItems: ["Matriz Riesgo", "Grupo Homogeneo"],
                type: "",
                company: ""
            };
        }, methods: {


            async generateReportGrupoHomogenio() {
                if (this.$refs.form.validate()) {
                    let reportList = [];
                    await this.$store.dispatch('getGruposHomogenio', this.company.id).then(response => {
                        this.$store.state.progress = false;
                        for (let i = 0; i < this.$store.state.gruposHomogenio.length; i++) {
                            let data = new Object();
                            data.PUESTO = this.$store.state.gruposHomogenio[i].companyJob.name;
                            data.SUCURSAL_AGENCIA_PLANTA = this.$store.state.gruposHomogenio[i].companyAgency.name;
                            data.TIPO = this.$store.state.gruposHomogenio[i].type.name;
                            data.ELEMENTO_PROCESO_PELIGROSO = this.$store.state.gruposHomogenio[i].element.name;
                            data.GRUPO = this.$store.state.gruposHomogenio[i].group;
                            reportList.push(data)
                        }
                    })
                    if (reportList.length == 0) {
                        alert('No existen registros.');
                    }
                    this.$store.state.progress = false;
                    return reportList;
                }
            },
            async generateReportMatrizRiesgo() {
                if (this.$refs.form.validate()) {
                    let reportList = [];
                    await this.$store.dispatch('getDangerousProcess', this.company.id).then(response => {
                        this.$store.state.progress = false;
                        for (let i = 0; i < this.$store.state.dangerousProcesses.length; i++) {
                            let data = new Object();
                            data.PUESTO = this.$store.state.dangerousProcesses[i].companyJob.name;
                            data.TIPO = this.$store.state.dangerousProcesses[i].type.name;
                            data.ELEMENTO_PROCESO_PELIGROSO = this.$store.state.dangerousProcesses[i].element.name;
                            data.VALOR = this.$store.state.dangerousProcesses[i].value;
                            reportList.push(data)
                        }
                    })
                    if (reportList.length == 0) {
                        alert('No existen registros.');
                    }
                    this.$store.state.progress = false;
                    return reportList;
                }
            },
        },
        computed: {},
        beforeCreate() {
            this.$store.dispatch('getCompanies').then(response => {
                this.cleanData()
            }, error => {
                this.$store.state.dialogError = true
            })
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/MatrizRiesgoGrupoHomogenioReport.vue